var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCircleDown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M256 496C388.58 496 496 388.58 496 256S388.58 16 256 16C123.418 16 16 123.42 16 256S123.418 496 256 496ZM129.219 265.875C131.688 259.891 137.531 256 144 256H208V160C208 142.327 222.327 128 240 128H272C289.673 128 304 142.327 304 160V256H368C374.469 256 380.312 259.891 382.781 265.875C385.266 271.859 383.891 278.734 379.313 283.313L267.313 395.313C261.065 401.56 250.935 401.56 244.688 395.313L132.688 283.313C128.109 278.734 126.734 271.859 129.219 265.875Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleDown);
export default __webpack_public_path__ + "static/media/circle-down.fd00a9a25397abd511d7b8792c485b91.svg";
export { ForwardRef as ReactComponent };